var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWirtualnaMataLogoEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477 105",
    style: {
      enableBackground: "new 0 0 477 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svg01{fill:#FFFFFF;}\n\t.svg02{fill:#00AEEF;}\n\t.svg03{fill:#ED1C24;}\n\t.svg04{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 30.8,
    className: "svg01",
    width: 18.9,
    height: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M74.5,49.9v-2.7c-8.7-1-15.6-7.8-16.8-16.4h-2.6v19.1H74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M98.3,30.8h-2.5c-1.2,8.4-7.8,15.1-16.2,16.3v2.8h18.7V30.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 6.9,
    className: "svg01",
    width: 18.9,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M57.7,25.7C58.8,17,65.7,10,74.5,9V6.9H55.1v18.8L57.7,25.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 30.8,
    className: "svg01",
    width: 18.9,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 79.3,
    className: "svg01",
    width: 19.4,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M47.6,79.3c-1.3,8.4-8,14.9-16.4,16.1v2.7H50V79.3H47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M7.1,74.2h2.4c1-8.8,7.9-15.8,16.6-17V55h-19V74.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 6.9,
    className: "svg01",
    width: 18.9,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M26,95.3c-8.4-1.1-15.1-7.7-16.4-16.1H7.1V98H26V95.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 79.3,
    className: "svg01",
    width: 18.7,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M95.9,25.7h2.4V6.9H79.6v2.2C88.1,10.3,94.8,17.2,95.9,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg01",
    d: "M31.1,55v2.2c8.7,1.2,15.6,8.2,16.6,17H50V55H31.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 55,
    className: "svg01",
    width: 18.7,
    height: 19.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 55,
    className: "svg01",
    width: 19.4,
    height: 19.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svg02",
    cx: 28.6,
    cy: 76.3,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg03",
    d: "M76.8,13.5c-8,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6s14.6-6.5,14.6-14.6S84.8,13.5,76.8,13.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg03",
    points: "98.3,49.9 79.6,49.9 74.5,49.9 55.1,49.9 55.1,30.8 55.1,25.7 55.1,6.9 50,6.9 50,25.7 50,30.8  50,49.9 31.1,49.9 26,49.9 7.1,49.9 7.1,55 26,55 31.1,55 50,55 50,74.2 50,79.3 50,98.1 55.1,98.1 55.1,79.3 55.1,74.2 55.1,55  74.5,55 79.6,55 98.3,55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M100.8,1.8H4.5C3.1,1.8,2,3,2,4.4v96.3c0,1.4,1.1,2.5,2.5,2.5h96.3c1.4,0,2.5-1.1,2.5-2.5V4.4 C103.4,3,102.2,1.8,100.8,1.8z M79.6,74.2V55h-5.1v19.2H55.1v5.1h19.4v18.8H55.1H50H31.1v-2.7c8.4-1.1,15.1-7.7,16.4-16.1H50v-5.1 h-2.3c-1-8.8-7.9-15.8-16.6-17V55H26v2.2c-8.7,1.2-15.6,8.2-16.6,17H7.1V55v-5.1V30.8H26v19.1h5.1V30.8H50v-5.1H31.1V6.9H50h5.1 h19.4V9c-8.8,1-15.7,8-16.8,16.7h-2.5v5.1h2.6c1.2,8.6,8.1,15.4,16.8,16.4v2.7h5.1v-2.8c8.4-1.2,15-7.9,16.2-16.3h2.5v19.1V55v19.2 H79.6z M98.3,79.3v18.8H79.6V79.3H98.3z M7.1,79.3h2.5c1.3,8.4,8,14.9,16.4,16.1v2.7H7.1V79.3z M14,76.3c0-8,6.5-14.6,14.6-14.6 s14.6,6.5,14.6,14.6s-6.5,14.6-14.6,14.6S14,84.3,14,76.3z M7.1,25.7V6.9H26v18.8L7.1,25.7z M98.3,6.9v18.8h-2.4 c-1.1-8.6-7.8-15.4-16.3-16.6V6.9H98.3z M91.3,28.1c0,8-6.5,14.6-14.6,14.6s-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6 S91.3,20.1,91.3,28.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M170.1,44.5c-3,2.5-7.2,3.9-12.1,3.9c-12.2,0-19.3-7.2-19.3-19.3c0-12,7.2-19.3,18.6-19.3 c10,0,16.1,4.9,16.1,10.5c0,3-2.3,5.1-5.2,5.1c-2.3,0-3.5-1.1-4.8-3.1c-1.5-2.2-3-3.4-5.9-3.4c-4.7,0-7,3.4-7,10.2 c0,6.6,2.5,10.1,7.2,10.1c2.2,0,3.8-0.7,5.1-2.4c0.5-0.7,1-1.8,2.1-2.8c0.8-0.8,2-1.2,3.4-1.2c3,0,5.3,2.2,5.3,5.1 C173.6,40.1,172.3,42.5,170.1,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M195.9,48.4c-11.7,0-19-7.3-19-19.3c0-11.9,7.3-19.3,19-19.3c11.8,0,19,7.4,19,19.3 C214.9,41,207.7,48.4,195.9,48.4z M195.9,19c-4.9,0-7.2,3.2-7.2,10.1c0,6.8,2.2,10,7.2,10c5,0,7.2-3.2,7.2-10 C203.1,22.3,200.9,19,195.9,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M247.5,44.3c-4.1,3-9.1,3-15.7,3h-4.9c-5.2,0-7.1-1.7-7.1-6.8v-23c0-5.1,1.8-6.8,7.1-6.8h7.2 c5.6,0,9.8,0.4,12.9,2.3c5,3.1,7.3,8.2,7.3,15.7C254.2,36.1,252,41.2,247.5,44.3z M234.8,20h-3.3v18h3.1c5.8,0,7.9-2.5,7.9-9 C242.5,22.8,240.2,20,234.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M265,47.8c-3.8,0-5.9-1.9-5.9-5.4V15.8c0-3.5,2.2-5.5,5.9-5.5c3.8,0,5.9,1.9,5.9,5.3v26.6 C270.8,45.8,268.7,47.8,265,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M305.6,47.8c-3.3,0-5.4-1.1-7.3-4.2l-7.5-12.3c-1.1-1.7-2-3.7-2.6-6.1c0.2,1.7,0.3,3.4,0.3,5v12.2 c0,3.5-1.9,5.4-5.5,5.4c-3.6,0-5.6-2.1-5.6-5.6v-26c0-3.8,2.4-6,6.5-6c2.9,0,4.9,1.2,6.6,4.1l7.5,12.3c1,1.6,1.9,3.7,2.9,6.2 c-0.3-1.7-0.3-3.4-0.3-5V15.8c0-3.5,2.1-5.5,5.6-5.5c3.6,0,5.6,1.8,5.6,5.3v26C311.8,45.7,309.7,47.8,305.6,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M348.8,47.9c-2.6,0-3.8-1.2-3.9-3.7c-2.7,2.9-6.3,4.2-11.3,4.2c-10.3,0-16.9-7.2-16.9-19.3 c0-11.8,7.3-19.3,19.1-19.3c9,0,14.4,4.1,14.4,8.9c0,2.8-1.9,4.7-5.1,4.7c-2.1,0-3-0.9-4.2-1.9c-1.4-1.2-2.5-2.5-5.3-2.5 c-4.7,0-7,3.6-7,10.8c0,6.6,2.4,9.9,7.1,9.9c3.5,0,6-1.8,6.6-4.4h-1.4c-3,0-4.5-1.2-4.5-3.7c0-2.8,1.7-4.1,5.3-4.1h4.8 c4.5,0,6.5,2.1,6.5,6.9v9.2C353.1,46.3,351.6,47.9,348.8,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M176.3,96.8c-3.5,0-5.5-1.9-5.5-5.3V78.2c0-0.7,0.1-2.8,0.1-6.4c-0.6,2.8-1.2,4.9-1.5,6.5l-3.8,15.2 c-0.6,2.4-2.1,3.3-4.9,3.3s-4.1-0.8-4.8-3.2l-3.8-14.8c-0.5-2-1-4.3-1.5-6.9c0.1,1.5,0.1,2.8,0.1,3.8c0,1.5,0,2.5,0,2.9v12.9 c0,3.4-2,5.3-5.5,5.3c-3.3,0-5-1.9-5-5.5V64.2c0-3.3,1.9-5.1,5.4-5.1h4.3c3.6,0,4.8,1.3,5.8,5.1l3.9,13.7c0.1,0.5,0.5,2.3,1.2,5.3 c0.4-2.2,0.8-3.9,1.2-5.3l4-14c1-3.5,2.4-4.8,5.7-4.8h4.3c3.5,0,5.4,1.8,5.4,5.1v27C181.4,94.9,179.6,96.8,176.3,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M213.9,96.9c-2.4,0-4.1-1.2-5-3.3l-0.8-2.2h-11.7l-0.8,2.2c-0.8,2.1-2.5,3.3-4.9,3.3c-3.3,0-5.3-2-5.3-5 c0-0.9,0.1-1.7,0.3-2.3l8.9-25c1.3-3.7,2.7-5.4,6-5.4h3.4c3.4,0,4.6,1.7,5.9,5.4l9,25c0.2,0.5,0.3,1.3,0.3,2.3 C219.2,94.9,217.1,96.9,213.9,96.9z M202.3,71.1l-3.7,12.6h7.4L202.3,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg04",
    d: "M246.8,69.2h-6.5v22.2c0,3.5-2,5.4-5.9,5.4c-3.7,0-5.9-2.1-5.9-5.6v-22h-6.5c-3.4,0-5.1-1.6-5.1-4.7 c0-3.1,1.8-4.8,5.2-4.8h24.6c3.4,0,5.1,1.7,5.1,5C251.9,67.6,250.2,69.2,246.8,69.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirtualnaMataLogoEn);
export default __webpack_public_path__ + "static/media/wirtualna_mata_logo_en.548167b4.svg";
export { ForwardRef as ReactComponent };